module.exports = __webpack_public_path__ + "static/forest-dead775b061edd644f1179d9c0b2c98d.jpg";